import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';

import { PortalRoutes } from '@app/app-routing.module';
import { UpsellEmailVariantEnum } from '@app/services/api/api.types';

import {
  TRIP_UPSELL_BANNER_COPY,
  TRIP_UPSELL_BANNER_EXPIRED_COPY,
  TripUpsellBannerCopy,
} from './trip-upsell-banner.constants';
import { formatCountdown, remainingMsUntil } from './trip-upsell-banner.util';

@Component({
  selector: 'trip-upsell-banner',
  templateUrl: './trip-upsell-banner.component.html',
  styleUrl: './trip-upsell-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TripUpsellBannerComponent implements OnInit, OnDestroy {
  PortalRoutes = PortalRoutes;
  TRIP_UPSELL_BANNER_EXPIRED_COPY = TRIP_UPSELL_BANNER_EXPIRED_COPY;

  @Input() emailVariant?: UpsellEmailVariantEnum | null;
  @Input() timerExpiresAt?: string | null;
  @Input({ required: true }) tripPortalLink!: string;

  changeDetectorRef = inject(ChangeDetectorRef);
  intervalId?: ReturnType<typeof setInterval>;

  copy: TripUpsellBannerCopy | null = null;
  isExpired = false;
  countdown = '';

  ngOnInit() {
    if (
      !this.timerExpiresAt ||
      (this.emailVariant !== UpsellEmailVariantEnum.EMAIL1 &&
        this.emailVariant !== UpsellEmailVariantEnum.EMAIL2)
    ) {
      return;
    }

    this.copy = TRIP_UPSELL_BANNER_COPY[this.emailVariant];
    this.syncTimerState();

    if (!this.isExpired) {
      this.intervalId = setInterval(() => this.syncTimerState(), 1000);
    }
  }

  ngOnDestroy() {
    this.clearInterval();
  }

  syncTimerState() {
    const remaining = remainingMsUntil(this.timerExpiresAt!);

    if (remaining <= 0) {
      this.isExpired = true;
      this.countdown = '00:00:00';
      this.clearInterval();
    } else {
      this.isExpired = false;
      this.countdown = formatCountdown(remaining);
    }

    this.changeDetectorRef.markForCheck();
  }

  clearInterval() {
    if (this.intervalId !== undefined) {
      clearInterval(this.intervalId);
      this.intervalId = undefined;
    }
  }
}
